import { NgIf } from '@angular/common';
import {
    Component,
    Inject,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from 'app/core/auth/auth.service';
import { IAuthResponse } from 'app/shared/model/security.model';
import { MatTabsModule } from '@angular/material/tabs';
import { SignUpFormComponent } from '../shared/sign-up-form/sign-up-form.component';
import { SignInFormComponent } from '../shared/sign-in-form/sign-in-form.component';
import { TwofaInstructionComponent } from '../shared/twofa-instruction/twofa-instruction.component';
import { TwofaFormComponent } from '../shared/twofa-form/twofa-form.component';
import { MatDividerModule } from '@angular/material/divider';
import { ForgotPasswordFormComponent } from '../shared/forgot-password-form/forgot-password-form.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export enum AuthPageType {
    SignIn = 'SignIn',
    ForgotPassword = 'forgotPassword',
}

export type CloseModalResponse = {
    didCreateUser: boolean | undefined;
}

@Component({
    selector: 'modal-auth',
    templateUrl: './modal-auth.component.html',
    styleUrls: ['./modal-auth.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    imports: [
        MatDividerModule,
        MatIconModule,
        MatTabsModule,
        NgIf,
        SignUpFormComponent,
        SignInFormComponent,
        TwofaInstructionComponent,
        TwofaFormComponent,
        ForgotPasswordFormComponent,
    ],
})
export class ModalAuthComponent implements OnInit, OnDestroy {
    allowRegister: boolean;
    twoFactorRequired: boolean = false;
    twoFactorActivationRequired: boolean = false;
    authPageType = AuthPageType;
    currentPage: AuthPageType = AuthPageType.SignIn;
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA)
        private data: {
            allowRegister: boolean | undefined;
        },
        private _authService: AuthService,
        private _dialogRef: MatDialogRef<ModalAuthComponent>
    ) {
        this.allowRegister = !!data.allowRegister;
    }

    /**
     * On init
     */
    ngOnInit(): void {}

    ngOnDestroy(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    signUpSuccess() {
        this.closeModal({
            didCreateUser: true
        });
    }

    signInSuccess(response: IAuthResponse) {
        // 2fa needed
        if (
            response.twoFactorActivationRequired ||
            response.twoFactorAuthenticationRequired
        ) {
            this.twoFactorRequired = true;
            this.twoFactorActivationRequired =
                response.twoFactorActivationRequired;
            return;
        }

        this.closeModal({
            didCreateUser: false
        });
    }

    redirectToForgetPassword() {
        this.currentPage = AuthPageType.ForgotPassword;
    }

    verifyTwoFaSuccess(response) {
        this.signInSuccess(response);
    }

    goBackToSignIn(forceLogout = false) {
        this.currentPage = AuthPageType.SignIn;
        this.twoFactorRequired = false;
        this.twoFactorActivationRequired = false;
        if (forceLogout) {
            this._authService.signOut();
        }
    }

    closeModal(data?: CloseModalResponse) {
        this._authService.verifySessionToken().subscribe();
        this._dialogRef.close(data);
    }
}
